import { render, staticRenderFns } from "./baseList.vue?vue&type=template&id=4711640e&scoped=true"
import script from "./baseList.vue?vue&type=script&lang=js"
export * from "./baseList.vue?vue&type=script&lang=js"
import style0 from "./baseList.vue?vue&type=style&index=0&id=4711640e&prod&lang=less&scoped=true"
import style1 from "./baseList.vue?vue&type=style&index=1&id=4711640e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4711640e",
  null
  
)

export default component.exports